import en from './en-US.json'
let zh = {}
let custom = {
  "含个资源": "含{count}个资源",
  "近天": "近{count}天",
  "第节": "第{num}节",
  "第章": "第{num}章",
  "第期课程": "第{num}期课程",
  "第空": "第{num}空",
  "英文": "English",
  "已选择个文件": "已选择{count}个文件",
  "查看全部个相关知识点": "查看全部{count}个相关知识点",
  "查看全部门相关课程": "查看全部{count}门相关课程",
  "查看全部门相关": "查看全部{count}门相关",
  "查看全部个相关": "查看全部{count}个相关",
  "查看全部个相关多媒体资源": "查看全部{count}个相关多媒体资源",
  "查看全部个相关课程地图": "查看全部{count}个相关课程地图",
  "查看全部个相关课程资源包": "查看全部{count}个相关课程资源包",
  "您选择了所有画面均不公开。将为您把改为“仅自己可见”状态。是否确认操作？": "您选择了所有画面均不公开。将为您把{name}改为“仅自己可见”状态。是否确认操作？",
  "搜索感兴趣的课程、、直播、教师": "搜索感兴趣的课程、{courseBack}、直播、教师",
}
Object.keys(en).map(key=>{
  zh[key] = key
  if(custom[key]){
    zh[key] = custom[key]
  }
})

export default zh